// Local API is enabled only when REACT_APP_USE_LOCAL_API=true at start time.
// Default (unset/false) keeps the production backend URL unchanged.
const useLocalApi = process.env.REACT_APP_USE_LOCAL_API === "true";

const apiHosts = useLocalApi
  ? {
      baseURL: "http://127.0.0.1:8000/api",
      url: "http://127.0.0.1:8000/",
    }
  : {
      // baseURL: "https://connecttovow.com/api",
      // url: "https://connecttovow.com/",
      baseURL: "https://backend.connecttovow.com/api",
      url: "https://backend.connecttovow.com/",
    };

export const environment = {
  ...apiHosts,
  onesignalAppId: "27fa0429-65d5-4544-b14c-2ad57e859071",
  chatBaseUrl: "https://chat.connecttovow.com",
  SOCKET_SERVER: "https://chat.connecttovow.com",
  brown_color: "#f37022",
  red_color: "#a00e0f",
  splash_color: "#310216",
  Coral_Red: "#e04a48",
  white_color: "#fff",
  lightPink: "#ffe7e7",
  teal: "#058787",
  // stripe_id:
  //   "pk_test_51RE5HAQTRCPS4xYj6GDiOL2fnKcUqulcxF6OrIescZUp7KXCpOCgettatzcz6XRSUC5aAJxbPQxi0gaogkWHQwZz00hSQaL8sG",
  stripe_id:
    "pk_live_51RE5H2KX8HgSm5MzcmFLo5ZKYiy0h6JfMEsuO0Ac2kMmHWOgJN1lnvmQ0fcAgE7YV9X9jnUXZNwDdX8CnRs22xVp00fq1hLxBK",
};
